import { requestCreateEventTrack as sendTrackingEvent } from '@/api/events'

const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0

const clickAnalysisMenuOptions = ({ optionName, stockTicker, stockCountry }) => sendTrackingEvent({
  eventName: window._statementdog_global_variable_.trackingEventTypes.clickedAnalysisMenuOptions,
  eventProperties: {
    option_name: optionName,
    stock_ticker: stockTicker,
    stock_country: stockCountry,
    is_mobile: isMobile,
  },
})

const viewStockChipData = ({
  action, stockTickerName, period, traderCode,
}) => sendTrackingEvent({
  eventName: window._statementdog_global_variable_.trackingEventTypes.viewedStockChipData,
  eventProperties: {
    action,
    stock_ticker_name: stockTickerName,
    period,
    trader_code: traderCode || '',
    is_mobile: isMobile,
  },
})

// 下面的 tracking event 單純做記錄用，不限制使用者使用次數
const clickTrackingBtnInAnalysis = () => sendTrackingEvent({
  eventName: window._statementdog_global_variable_.trackingEventTypes.clickedTrackingBtnInAnalysis,
  eventProperties: {
    is_mobile: isMobile,
  },
})

const clickFeed = ({
  contentType,
  contentTitle,
  contentSource,
  stock,
  feedId,
  feedableType,
  feedableId,
}) => sendTrackingEvent({
  eventName: window._statementdog_global_variable_.trackingEventTypes.clickFeed,
  eventProperties: {
    version: 'v2',
    clickedFrom: window.location.href,
    contentType,
    contentTitle,
    contentSource,
    stock,
    feedId,
    feedableType,
    feedableId,
    is_mobile: isMobile,
  },
})

const viewStockHealthCheckModuleDetail = ({ optionName, stockTickerName }) => sendTrackingEvent({
  eventName: 'Viewed stock health check module detail',
  eventProperties: {
    option_name: optionName,
    stock_ticker_name: stockTickerName,
    is_mobile: isMobile,
  },
})

// 目前只有 clickedAnalysisMenuOptions、viewedStockChipData 會限制使用者使用次數
export default {
  clickAnalysisMenuOptions,
  clickTrackingBtnInAnalysis,
  clickFeed,
  viewStockHealthCheckModuleDetail,
  viewStockChipData,
}
